import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ShieldCheck } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Guarantee() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection className="bg-barber-dark/30" data-id="element-102">
      <div className="max-w-3xl mx-auto text-center" data-id="element-103">
        <ShieldCheck className="text-barber-gold mx-auto mb-6" size={64} data-id="element-104" />
        <h2 className="text-3xl md:text-4xl font-oswald font-bold mb-6 tracking-wide" data-id="element-105">
          {t.guarantee.title}
        </h2>
        <div className="space-y-4 text-xl text-gray-300" data-id="element-106">
          <p data-id="element-107">{t.guarantee.p1}</p>
          <p data-id="element-108">{t.guarantee.p2}</p>
          <p className="text-barber-gold font-oswald font-bold text-2xl mt-8" data-id="element-109">
            {t.guarantee.p3}
          </p>
        </div>
      </div>
    </AnimatedSection>;
}